import { memo, useMemo } from 'react';
import ReactFlowRules, { Edge, Node } from 'reactflow';

import { SidePanel } from '@/lib/v2/organisms/SidePanel';

import FormCondition from '@/modules/RulesModule/components/FormCondition';
import FormRule from '@/modules/RulesModule/components/FormRule';
import { useAutoLayout, useFlowManagement } from '@/modules/RulesModule/hooks';
import { FormTypes, NodeData } from '@/modules/RulesModule/interfaces';
import { EDGE_TYPES, NODE_TYPES } from '@/modules/RulesModule/types';

const Edges = ({
  initialNodes,
  initialEdges,
}: {
  initialNodes: Node<NodeData>[];
  initialEdges: Edge[];
}) => {
  const {
    edges,
    nodes,
    handleEdgeClick,
    onEdgesChange,
    onNodesChange,
    handleNodeClick,
    toggleSidePanel,
    currentFormType,
  } = useFlowManagement({ initialNodes, initialEdges });

  const isRuleForm = useMemo(() => currentFormType === FormTypes.RULE, [currentFormType]);

  useAutoLayout();

  return (
    <>
      <ReactFlowRules
        deleteKeyCode={null}
        edgeTypes={EDGE_TYPES}
        edges={edges}
        nodeTypes={NODE_TYPES}
        nodes={nodes}
        nodesConnectable={false}
        nodesDraggable={false}
        panOnDrag={false}
        panOnScroll={false}
        zoomOnDoubleClick={false}
        zoomOnScroll={false}
        onEdgeClick={handleEdgeClick}
        onEdgesChange={onEdgesChange}
        onNodeClick={handleNodeClick}
        onNodesChange={onNodesChange}
      />
      <SidePanel noPadding open={toggleSidePanel} side="right">
        {isRuleForm ? <FormRule /> : <FormCondition />}
      </SidePanel>
    </>
  );
};

export default Edges;
